import React from 'react';
import styles from './MoonshotError.less';

export const MoonshotError: React.FC = ({ children }) => {
  return <div className={styles.error}>{children}</div>;
};
